import React, { Component } from 'react';
import { Alert } from 'reactstrap';
import { AgGridReact } from 'ag-grid-react';

export default class ProfilesAdminList extends Component {
    constructor(props) {
        super(props);

        document.title = "Profiles List";
        this.state = {
            profiles: [],
            columnDefs: [
                { field: 'id', headerName: 'Id', filter: true, floatingFilter: true, minWidth: 100 },
                {
                    field: 'name',
                    headerName: 'Name',
                    filter: true,
                    floatingFilter: true,
                    valueGetter: (params) => {
                        return (
                            (params.data?.lastName ? params.data.lastName + ", " : "") +
                            (params.data?.firstName ? params.data.firstName : "") +
                            (params.data?.middleName ? " " + params.data.middleName : "")
                        );
                    }
                },
                {
                    field: 'address',
                    headerName: 'Mailing Address',
                    filter: true,
                    floatingFilter: true,
                    valueGetter: (params) => {
                        return (
                            (params.data?.mailingAddress1 ? params.data.mailingAddress1 : "") +
                            (params.data?.mailingCity ? ", " + params.data.mailingCity : "")
                        )
                    }
                },
                { field: 'email', headerName: 'Email Address', filter: true, floatingFilter: true },
                { field: 'mobilePhone', headerName: 'Mobile Phone', filter: true, floatingFilter: true },
                { field: 'comments', headerName: 'Comments', filter: true, floatingFilter: true },
                {
                    field: 'isActive',
                    headerName: 'Is Active',
                    filter: true,
                    floatingFilter: true,
                    valueGetter: (params) => {
                        return params.value === true ? 'Yes' : 'No';
                    }
                }
            ],
            defaultColDef: {
                sortable: true,
                autoHeight: true,
                resizable: true,
                floatingFilter: true
            },
        };
    }

    componentDidMount() {
        fetch('/api/profiles', {
            method: 'GET'
        })
        .then(resp => resp.json())
        .then(data => {
            this.setState({ profiles: data });
        })
    }

    handleRowClick = (id) => {
        this.props.history.push('profiles/' + id);
    } 

    truncateText = (desc, maxLen) => {
        return (desc && desc.length > maxLen) ? desc.substring(0, maxLen) + ' ...' : desc || ''
    }

    render() {
        return (
            <div>
                <Alert color='info'>
                    <p className='mb-0'>Below is a list of all the member profiles, click one to view the profile's information and add comments.</p>
                </Alert>                
                <br />                
                <div style={{ height: "70vh" }}>
                    <div className="ag-theme-alpine" style={{ width: "100%", height: "100%" }}>
                        <AgGridReact
                            ref={this.gridRef} // Ref for accessing Grid's API
                            rowData={this.state.profiles} // Row Data for Rows
                            columnDefs={this.state.columnDefs} // Column Defs for Columns
                            defaultColDef={this.state.defaultColDef} // Default Column Properties
                            animateRows={true} // Optional - set to 'true' to have rows animate when sorted or filtered
                            rowSelection='single' // Options - allows click selection of rows
                            onCellClicked={(params) => this.handleRowClick(params.data.id)} // on row click
                            onFirstDataRendered={(params) => params.api.autoSizeAllColumns()}
                            pagination={true}
                            paginationPageSize={10}
                            paginationPageSizeSelector={[10, 20, 50, 100]}
                        />
                    </div>
                </div>
            </div>
        )
    }
}